"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reducers = _interopRequireDefault(require("../../profile/masterAPI/redux/reducers"));
var _reducer = _interopRequireDefault(require("../../onboarding/redux/reducer"));
var _reducer2 = _interopRequireDefault(require("../../auth/login/redux/reducer"));
var _reducer3 = _interopRequireDefault(require("../../../teleconsultant/appointment/redux/reducer"));
var _reducers2 = _interopRequireDefault(require("../../profile/profile/redux/reducers"));
var _reducer4 = _interopRequireDefault(require("../../auth/otp/redux/reducer"));
var _reducer5 = _interopRequireDefault(require("../../appConfig/redux/reducer"));
var _reducer6 = _interopRequireDefault(require("../../loyalty/redux/reducer"));
var _reducer7 = _interopRequireDefault(require("../../mypayments/redux/reducer"));
var _reducer8 = _interopRequireDefault(require("../../settings/redux/reducer"));
var _reducer9 = _interopRequireDefault(require("../../cms/redux/reducer"));
var _reducer10 = _interopRequireDefault(require("../../healthProfile/redux/reducer"));
var _redux = require("redux");
var _reducer11 = _interopRequireDefault(require("../../nps/redux/reducer"));
var _reducer12 = _interopRequireDefault(require("../../commonUtils/redux/reducer"));
var _reducer13 = _interopRequireDefault(require("../../identityService/redux/reducer"));
var _reducer14 = _interopRequireDefault(require("../../auth/uaepass/redux/reducer"));
var _reducer15 = _interopRequireDefault(require("../../authService/redux/reducer"));
// Redux: Root Reducer
var _default = exports.default = (0, _redux.combineReducers)({
  ..._reducers.default,
  ..._reducer.default,
  ..._reducer2.default,
  ..._reducer3.default,
  ..._reducers2.default,
  ..._reducer4.default,
  ..._reducer5.default,
  ..._reducer6.default,
  ..._reducer7.default,
  ..._reducer8.default,
  ..._reducer9.default,
  ..._reducer11.default,
  ..._reducer12.default,
  ..._reducer10.default,
  ..._reducer13.default,
  ..._reducer14.default,
  ..._reducer15.default
});